import he from 'date-format-parse/lib/locale/he';

const LANGS = {
  he: {
    formatLocale: he,
    yearFormat: 'YYYY',
    monthFormat: 'MMM',
    monthBeforeYear: true,
  },
};

export const datePickerLang = locale => LANGS[locale] || locale;

export const closeDatePickerOnOutsideClick = picker => {
  const onMouseDown = ({ target }) => {
    const popup = picker.$refs.popup && picker.$refs.popup.$el;
    if (picker.$el.contains(target) || (popup && popup.contains(target))) {
      return;
    }
    picker.closePopup();
  };
  document.addEventListener('mousedown', onMouseDown, true);
  return () => document.removeEventListener('mousedown', onMouseDown, true);
};
